import React, { Component } from "react";
import { PageHeader, Tag, notification, Space, Typography, Tabs } from "antd";
import {
  PlusOutlined,
  EditOutlined,
  StopOutlined,
  CheckCircleOutlined,
  TeamOutlined,
  ShopOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { ButtonItem, SegmentedItem } from "../../../../Components/Items";
import TableItemDinamico from "../../../../Components/TableItemDinamico";
import ModalAsignarVendedores from "../Components/ModalAsignarVendedores";
import ConfiguracionShopify from "./ConfiguracionShopify";
import ConfiguracionCamposLead from "./ConfiguracionCamposLead";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import axios from "axios";
import { connect } from "react-redux";

const { Text } = Typography;

class ConfiguracionCRM extends Component {
  state = {
    embudos: [],
    loading: false,
    totalRecords: 0,
    valorFiltro: 2, // 1: Activos, 0: Inactivos, 2: Todos
    modalAsignarVisible: false,
    embudoParaAsignar: null,
  };

  fetchData = (params) => {
    this.setState({ loading: true });

    axios
      .post(
        "embudos/selectEmbudos",
        { ...params, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            embudos: res.data.data,
            totalRecords: res.data.totalRecords,
          });
        } else {
          notification.error({
            message: "Error",
            description:
              res.data.message || "No se pudieron cargar los embudos.",
          });
        }
      })
      .catch((error) => {
        console.error("Error al cargar embudos:", error);
        notification.error({
          message: "Error de conexión",
          description: "Ocurrió un problema de red al cargar la lista.",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  crearEmbudo = () => {
    this.props.history.push("/panel/crmConfiguracion/embudo/nuevo");
  };

  editarEmbudo = (id) => {
    this.props.history.push(`/panel/crmConfiguracion/embudo/${id}`);
  };

  toggleEstado = (embudo) => {
    const nuevoEstado = !embudo.estado;
    axios
      .post(
        "embudos/cambiarEstadoEmbudo",
        {
          _id: embudo._id,
          nombreEmbudo: embudo.nombreEmbudo,
          estado: nuevoEstado,
        },
        {
          headers: this.props.headersToken,
        },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState(
            (prevState) => ({
              embudos: prevState.embudos.map((e) =>
                e._id === embudo._id ? { ...e, estado: nuevoEstado } : e,
              ),
            }),
            () => {
              notification.success({
                message: `Embudo ${nuevoEstado ? "Habilitado" : "Deshabilitado"}`,
              });
            },
          );
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch((err) => {
        console.error(err);
        notification.error({ message: "Error al cambiar el estado." });
      });
  };

  atras() {
    this.props.history.goBack();
  }

  render() {
    const columnas = [
      {
        title: "Nombre del Embudo",
        dataIndex: "nombreEmbudo",
        buscar: "nombreEmbudo",
        render: (text, record) => (
          <Text strong style={{ color: record.estado ? "#172b4d" : "#a5adba" }}>
            {text}
          </Text>
        ),
      },
      {
        title: "Cantidad de Etapas",
        dataIndex: "etapas",
        render: (etapas) => (
          <Tag color="blue">{etapas?.length || 0} etapas</Tag>
        ),
      },
      {
        title: "Etapa Final (Cierre)",
        dataIndex: "etapas",
        render: (etapas) => {
          if (!etapas || etapas.length === 0) return "-";
          const ultimaEtapa = etapas[etapas.length - 1];
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: ultimaEtapa.color,
                }}
              ></div>
              {ultimaEtapa.nombre}
            </div>
          );
        },
      },
      {
        title: "Estado",
        dataIndex: "estado",
        render: (estado) =>
          estado ? (
            <Tag color="green">Activo</Tag>
          ) : (
            <Tag color="red">Inactivo</Tag>
          ),
      },
      {
        title: "Acciones",
        dataIndex: "acciones",
        width: 150,
        render: (text, record) => (
          <Space>
            <ButtonItem
              disabled = {!this.props.permisoEditarEmbudo}
              size="small"
              icon={<EditOutlined />}
              onClick={() => this.editarEmbudo(record._id)}
              tooltip="Editar estructura del embudo"
            />
            <ButtonItem
              disabled = {!this.props.permisoHabilitarDeshabilitarEmbudo}
              rojo={record.estado}
              verde={!record.estado}
              size="small"
              icon={record.estado ? <StopOutlined /> : <CheckCircleOutlined />}
              onClick={() => this.toggleEstado(record)}
              tooltip={
                record.estado ? "Deshabilitar Embudo" : "Habilitar Embudo"
              }
            />
            <ButtonItem
              disabled={!this.props.permisoMasterCRM}
              lila
              size="small"
              icon={<TeamOutlined />}
              onClick={() =>
                this.setState({ modalAsignarVisible: true, embudoParaAsignar: record })
              }
              tooltip="Asignar vendedores"
            />
          </Space>
        ),
      },
    ];

    return (
      <div style={{ padding: "0 20px" }}>
        <ModalAsignarVendedores
          visible={this.state.modalAsignarVisible}
          embudo={this.state.embudoParaAsignar}
          onCancel={() =>
            this.setState({ modalAsignarVisible: false, embudoParaAsignar: null })
          }
          onExito={() =>
            this.setState({ modalAsignarVisible: false, embudoParaAsignar: null })
          }
        />
        <PageHeader
          title="Configuración CRM"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 15,
          }}
          onBack={this.atras.bind(this)}
        />

        <style>{tabStyles}</style>
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            overflow: "hidden",
            padding: 20,
          }}
        >
        <Tabs defaultActiveKey="embudos" className="custom-tabs">
          <Tabs.TabPane
            key="embudos"
            tab={
              <span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>
                <TeamOutlined style={{ marginRight: 6 }} />
                Embudos
              </span>
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              {window.innerWidth > 1000 && (
                <>
                  <SegmentedItem
                    options={[
                      { label: "Activos", value: 1 },
                      { label: "Inactivos", value: 0 },
                      { label: "Todos", value: 2 },
                    ]}
                    onChange={(value) => {
                      if (this.tableRef) {
                        this.tableRef.updateExternalFilters({ estado: value });
                      }
                      this.setState({ valorFiltro: value });
                    }}
                    value={this.state.valorFiltro}
                  />
                  <div
                    style={{
                      borderLeft: "1px solid #d9d9d9",
                      height: "24px",
                      margin: "0 5px",
                    }}
                  />
                </>
              )}
              <ButtonItem
                azul
                disabled={!this.props.permisoAgregarEmbudo}
                icon={<PlusOutlined />}
                className="botonAgregar"
                onClick={this.crearEmbudo}
              >
                Nuevo Embudo
              </ButtonItem>
            </div>

            <TableItemDinamico
              onRef={(node) => (this.tableRef = node)}
              columns={columnas}
              dataSource={this.state.embudos}
              loading={this.state.loading}
              totalRecords={this.state.totalRecords}
              onFetchData={this.fetchData}
              rowKey="_id"
            />
          </Tabs.TabPane>

          <Tabs.TabPane
            key="shopify"
            tab={
              <span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>
                <ShopOutlined style={{ marginRight: 6 }} />
                Shopify
              </span>
            }
          >
            <ConfiguracionShopify />
          </Tabs.TabPane>

          <Tabs.TabPane
            key="camposLead"
            tab={
              <span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>
                <FormOutlined style={{ marginRight: 6 }} />
                Mis Campos
              </span>
            }
          >
            <ConfiguracionCamposLead />
          </Tabs.TabPane>
        </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoMasterCRM:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a170cabe0d8ec48005e197f",
    )?.activado,
  permisoAgregarEmbudo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "69e999d1200bae6f82429058",
    )?.activado,
  permisoEditarEmbudo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "69e99995200bae6f82429056",
    )?.activado,
  permisoHabilitarDeshabilitarEmbudo:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "69e999b1200bae6f82429057",
    )?.activado,
});

export default connect(mapStateToProps)(ConfiguracionCRM);
